import { hasAnyPermission } from "@/lib/permissions";

export interface Portal {
  key: string;
  path: string;
  titleKey: string;
  descriptionKey: string;
  /** Any-of permissions that unlock this portal. */
  permissions: string[];
}

/**
 * The four permission-scoped portals advertised on the landing page and used
 * to route a user to their highest-priority dashboard after login.
 */
export const PORTALS: Portal[] = [
  {
    key: "admin",
    path: "/admin",
    titleKey: "landing.adminPortal",
    descriptionKey: "landing.adminDescription",
    permissions: ["users.read", "loads.read", "slots.approve", "customers.read"],
  },
  {
    key: "warehouse",
    path: "/loadboard",
    titleKey: "landing.warehousePortal",
    descriptionKey: "landing.warehouseDescription",
    permissions: ["loadboard.read", "loads.read"],
  },
  {
    key: "depot",
    path: "/depot",
    titleKey: "landing.depotPortal",
    descriptionKey: "landing.depotDescription",
    permissions: ["depot.read", "loads.read"],
  },
  {
    key: "haulier",
    path: "/haulier",
    titleKey: "landing.haulierPortal",
    descriptionKey: "landing.haulierDescription",
    permissions: ["haulier.loads.read", "loads.read"],
  },
];

/** The highest-priority dashboard the principal's permissions allow. */
export function homeFor(permissions: readonly string[]): string {
  for (const portal of PORTALS) {
    if (hasAnyPermission(permissions, ...portal.permissions)) {
      return portal.path;
    }
  }
  return "/";
}
